import React, {useEffect, useState} from "react";
import {Controller, useForm} from "react-hook-form";
import {Network} from "../../../utils/network";

import {useSelector} from "react-redux";

import {
  Linking,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import { Button } from "../../../components/core/Button";
import {globalFontStyle} from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import BouncyCheckbox from "react-native-bouncy-checkbox";
import AsyncStorage from "@react-native-async-storage/async-storage";
import {Input} from "../../../components/core/Input";
import {globalConst} from "../../../utils/globalConstant";
import {isMobile} from "../../../utils/commonMethods";
import {CountryButton, CountryPicker} from "react-native-country-codes-picker";
import {CountryRegEx, RegEx} from "../../../utils/commonMethods";
import ShowError from "../../../common/ShowError";
import GoogleLoginRT from "../../../common/googleLogin";
import {globalImport} from "../../../common/globalImports";
import Width from "../../../assets/Width";
import AppleButtonCustom from "./AppleButtonCustom";

function EmailLogin({
  onLoginSubmit,
  onPromoSuccessSet,
  isIndia,
  showMobileOnly,
}) {
  const [error, setError] = useState("");
  const [IspromoSuccess, setIsPromoSuccess] = useState(null);

  const globalConfigData = useSelector(
    state => state.utilReducer.globalConfigData,
  );
  let otpReSuccess = useSelector(({login}) => login.interimRegisterSuccess);
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: {errors, isValid},
    watch,
  } = useForm({mode: "onChange"});

  const email = watch("emailInput");

  const termsAndCondition = globalConfigData?.termsAndCondition;
  const privacyPolicy = globalConfigData?.privacyPolicy;
  const amlPolicy = globalConfigData?.antiMoneyLaundering;

  const onLinkClick = (e, link) => {
    e.preventDefault();
    if (link) {
      Linking.openURL(link);
    }
  };

  // useEffect(() => {
  //     getPromo();
  // }, []);

  useEffect(() => {
    if (otpReSuccess?.verified === false) {
      setError(otpReSuccess?.msg);
    }
  }, [otpReSuccess]);

  const {
    register: registerPromo,
    control: controlPromo,
    formState: {errors: errors2, isValid: isValid2},
    handleSubmit: handleSubmitPromo,
    setValue,
  } = useForm({
    mode: "onChange",
  });

  const getPromo = async () => {
    const promo = await AsyncStorage.getItem("promoCode");
    if (promo && promo !== "undefined" && promo !== undefined) {
      setValue("promoCode", promo, {shouldValidate: true});
      onPromoApply(promo);
    }
  };

  const onPromoApply = async promo => {
    const inputObj = {
      coupon: promo,
    };
    const res = await Network.verifyCouponCode(inputObj);

    // trackMoengageEvent("Added Referral Code", {
    //   Valid: res?.data?.isvalid ? true : false,
    //   Code: promo,
    // });

    if (!res?.data?.isvalid) {
      onPromoSuccessSet("");
      setIsPromoSuccess({
        val: "Apply",
        divClass: {borderColor: Colors.red, borderWidth: 2},
        message: res?.data?.message,
        errorClass: {color: Colors.red},
      });
    } else {
      onPromoSuccessSet(promo);
      setIsPromoSuccess({
        val: "Remove",
        divClass: {borderColor: Colors.green, borderWidth: 2},
        message: res?.data?.message,
        errorClass: {color: Colors.green},
      });
    }
  };

  useEffect(() => {
    let timeout;
    if (error) {
      timeout = setTimeout(() => {
        setError("");
      }, 5000);
    }

    return () => {
      timeout && clearTimeout(timeout);
    };
  }, [error]);

  const onFormSubmit = (source, event) => {
    onLoginSubmit(email, false, source);
  };
  const onSubmitPromoCode = (data, event) => {
    onPromoApply(data?.promoCode);
    event.preventDefault();
  };

  return (
    <View
      style={{
        paddingTop: 30,
        marginBottom: 20,
        // height: '100%',
        backgroundColor: Colors.bgWhite,
      }}>
      <View style={{paddingHorizontal: 16}}>
        <View>
          <Text
            style={{
              width: 80,
              zIndex: 10,
              textAlign: "center",
              ...globalFontStyle.appFontSmallText,
              color: Colors.black,
              position: "relative",
              backgroundColor: Colors.bgWhite,
              top: 10,
              left: 20,
            }}>
            (Enter email)
          </Text>
          <View style={[styles.inputDiv]}>
            <Input
              name="emailInput"
              placeholder="ex: abc@mail.com"
              control={control}
              variant="default"
              size="default"
              rules={{
                required: "Please enter email",
                pattern: {
                  value: RegEx.email,
                  message: "Please enter a valid email",
                },
              }}
            />
          </View>
          {(errors?.emailInput?.type === "required" ||
            errors?.emailInput?.type === "pattern") && (
            <ShowError
              error={{
                val: "Retry",
                message: errors?.emailInput.message,
                errorClass: {color: Colors.red},
                borderColor: Colors.red,
              }}
            />
          )}
        </View>
        {/* {isIndia && (
                                <View>
                                    <Text
                                        style={{
                                            width: 120,
                                            zIndex: 10,
                                            textAlign: "center",
                                            ...globalFontStyle.appFontSmallText,
                                            color: Colors.black,
                                            position: "relative",
                                            backgroundColor: Colors.bgWhite,
                                            top: 10,
                                            left: 20,
                                        }}>
                                        Enter Promo Code (if any)
                                    </Text>
                                    <View
                                        style={[
                                            styles.inputDiv,
                                            IspromoSuccess ? IspromoSuccess?.divClass : null,
                                        ]}>
                                        <CustomInput
                                            name="promoCode"
                                            placeholder="ex: TRADEX50"
                                            control={controlPromo}
                                            isLoginStyle={true}
                                            isTextInput={true}
                                            rules={{
                                                required: "Please enter a valid promo code",
                                            }}
                                        />
                                        <TouchableOpacity
                                            style={[
                                                {
                                                    marginRight: 10,
                                                    paddingVertical: 6,
                                                    paddingHorizontal: 10,
                                                    borderRadius: 50,
                                                    backgroundColor: Colors.bgWhite,
                                                    borderColor: Colors.black,
                                                    borderWidth: 1,
                                                },
                                                IspromoSuccess?.val === "Remove"
                                                    ? {backgroundColor: Colors.black}
                                                    : null,
                                            ]}
                                            onPress={
                                                isValid2 ? handleSubmitPromo(onSubmitPromoCode) : () => {}
                                            }>
                                            <Text
                                                style={[
                                                    {
                                                        ...globalFontStyle.appFontSubText,
                                                        color: Colors.black,
                                                    },
                                                    IspromoSuccess?.val === "Remove"
                                                        ? {color: Colors.bgWhite}
                                                        : null,
                                                ]}>
                                                {IspromoSuccess ? IspromoSuccess?.val : "Apply"}
                                            </Text>
                                        </TouchableOpacity>
                                    </View>
                                    {IspromoSuccess?.message && <ShowError error={IspromoSuccess} />}
                                </View>
                            )} */}
      </View>

      <View
        style={[
          {
            marginTop: 20,
            paddingBottom: 15,
            marginHorizontal: 16,
          },
        ]}>
        <View
          style={{
            flexDirection: isMobile() ? "column" : "row",
            justifyContent: "center",
          }}>
          <Button
            variant={isValid ? "black" : "disabled"}
            disabled={!isValid}
            onPress={handleSubmit(() => onFormSubmit())}
            style={[
              !globalImport.isWeb ? {flex: 0} : !isMobile() ? {flex: 1} : {},
              {marginBottom: 20}
            ]}
          >
            Proceed
          </Button>
        </View>

        {!showMobileOnly ? (
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginTop: 20,
            }}>
            {/*<BouncyCheckbox*/}
            {/*  size={18}*/}
            {/*  disableText={false}*/}
            {/*  fillColor={Colors.tradexBlue}*/}
            {/*  unfillColor="#FFFFFF"*/}
            {/*  iconStyle={{borderColor: 'red'}}*/}
            {/*  innerIconStyle={{borderWidth: 1}}*/}
            {/*  onPress={setSelection}*/}
            {/*/>*/}
            <Text
              style={{
                ...globalFontStyle.appFontSmallText,
                color: Colors.grey,
                flex: 1,
                textAlign: "center",
              }}>
              By contnuing, you agree to our
              <Text
                style={{
                  ...globalFontStyle.appFontSmallText,
                  color: "#0d6efd",
                }}
                onPress={e =>
                  onLinkClick(
                    e,
                    privacyPolicy ||
                      "https://tradexapp.zendesk.com/hc/en-us/articles/7198021845149-Privacy-Policy",
                  )
                }>
                {" "}
                Privacy Policy,{" "}
              </Text>
              <Text
                className="app-font-small-text"
                style={{
                  ...globalFontStyle.appFontSmallText,
                  color: "#0d6efd",
                }}
                onPress={e =>
                  onLinkClick(
                    e,
                    termsAndCondition ||
                      "https://tradexapp.zendesk.com/hc/en-us/articles/7197989869213-Terms-Conditions",
                  )
                }>
                Terms{" "}
              </Text>
              &{" "}
              <Text
                className="app-font-small-text"
                style={{
                  ...globalFontStyle.appFontSmallText,
                  color: "#0d6efd",
                }}
                onPress={e =>
                  onLinkClick(
                    e,
                    amlPolicy ||
                      "https://tradexapp.zendesk.com/hc/en-us/articles/11341149311261-Anti-Money-Laundering-Policy",
                  )
                }>
                AML Policy.
              </Text>
            </Text>
          </View>
        ) : null}
      </View>

      {error !== null && error !== "" && (
        <Text style={styles.loginErrorBar}>{error}</Text>
      )}
    </View>
  );
}

export default React.memo(EmailLogin);

const styles = StyleSheet.create({
  loginErrorBar: {
    ...globalFontStyle.appFontSubText,
    backgroundColor: "#ff2626",
    paddingVertical: 8,
    width: "100%",
    paddingLeft: 5,
    alignItems: "center",
    color: Colors.bgWhite,
  },
  inputDiv: {
    marginBottom: 10,
  },
});
